module.exports = __webpack_public_path__ + "img/frame (110).885a7a76.jpg";